import { render, staticRenderFns } from "./dischargeFacDetail.vue?vue&type=template&id=3313f63b"
import script from "./dischargeFacDetail.vue?vue&type=script&lang=js"
export * from "./dischargeFacDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3313f63b')) {
      api.createRecord('3313f63b', component.options)
    } else {
      api.reload('3313f63b', component.options)
    }
    module.hot.accept("./dischargeFacDetail.vue?vue&type=template&id=3313f63b", function () {
      api.rerender('3313f63b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/gas/baseinfo/dischargeFacDetail.vue"
export default component.exports